import { Radio, RadioChangeEvent } from "antd"
import { TableOutlined, UnorderedListOutlined } from "@ant-design/icons"
import { DisplayProjects } from "../types/project.type"

interface DisplayTypeProps {
  displayType: DisplayProjects
  setDisplayType: (type: DisplayProjects) => void
}

const DisplayType: React.FC<DisplayTypeProps> = ({ displayType, setDisplayType }) => {
  const handleChange = (e: RadioChangeEvent) => {
    setDisplayType(e.target.value)
  }

  return (
    <Radio.Group value={displayType} onChange={handleChange}>
      <Radio.Button value={DisplayProjects.TABLE}>
        <TableOutlined />
      </Radio.Button>
      <Radio.Button value={DisplayProjects.LIST}>
        <UnorderedListOutlined />
      </Radio.Button>
    </Radio.Group>
  )
}

export default DisplayType
